import { cn } from "@/lib/utils";
import type { GuestCatalogViewMode } from "@/components/guest-catalog/guestCatalogViewMode";

function Pulse({ className }: { className?: string }) {
  return <div className={cn("animate-pulse rounded-md bg-gray-200/80", className)} aria-hidden />;
}

export function GuestCatalogCardsSkeleton({ count = 4 }: { count?: number }) {
  return (
    <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4" aria-busy="true">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="space-y-3 rounded-lg border border-gray-100 bg-white p-3">
          <Pulse className="aspect-[3/4] w-full" />
          <Pulse className="h-4 w-full" />
          <Pulse className="h-3 w-2/3" />
        </div>
      ))}
    </div>
  );
}

export function GuestCatalogListSkeleton({ rows = 6 }: { rows?: number }) {
  return (
    <div
      className="divide-y divide-gray-100 rounded-lg border border-gray-200 bg-white"
      aria-busy="true"
    >
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="flex gap-4 p-4">
          <Pulse className="h-20 w-16 shrink-0" />
          <div className="flex-1 space-y-2">
            <Pulse className="h-4 w-3/4" />
            <Pulse className="h-3 w-1/2" />
          </div>
        </div>
      ))}
    </div>
  );
}

export function GuestCatalogResultsSkeleton({ viewMode }: { viewMode: GuestCatalogViewMode }) {
  return viewMode === "grid" ? (
    <GuestCatalogCardsSkeleton count={8} />
  ) : (
    <GuestCatalogListSkeleton rows={8} />
  );
}
